import React from 'react';
import { Header } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import DictionaryLookupDropdown from '../containers/DictionaryLookupDropdown';
import DictionaryChanger from '../../dictionaries/containers/DictionaryChanger';
import LookupButtons from '../containers/LookupButtons';

const LookupInformationHeader = ({
  category,
  code,
  canEdit,
  errors,
  count,
}) => (
  <Header as="h4" className="aridhia-lookup-information-header font-weight-dark relative">
    <div className={canEdit ? 'pt-3' : undefined}>
      {count === 0 && (<FormattedMessage id="dataset.dictionary.showing.none.header" />)}
      {count > 0 && (
        <>
          <FormattedMessage id="dataset.dictionary.showing.header" />
          <DictionaryLookupDropdown />
        </>
      )}
      <FormattedMessage id="dataset.dictionary.showing.in.header" />
      <DictionaryChanger category={category} code={code} saveErrors={errors} />
    </div>
    {canEdit && (<LookupButtons />)}
  </Header>
);

export default LookupInformationHeader;
